// Only initialize if not embedded in an iFrame
if (window.top === window.self) {
  // Adjust margin of pg-base according to height of topBlock
  // let $pgBase = document.querySelector('.pg-base')
  // let $topBlock = document.querySelector('.topBlock')
  // if ($topBlock && $pgBase) {
  //   $pgBase.style.marginTop = `${document.querySelector('.topBlock').offsetHeight}px`
  // }

  window.addEventListener('DOMContentLoaded', function () {
    var $header = document.querySelector('.aps-header')
    
    if ($header) {
      var $form = document.getElementById('form')
      var $main = document.querySelector('.pgMbGn-middle')
      var isHome = $form && $form.getAttribute('action').includes('aliaspath=%2fHome')
      var scrollY = 0

      if (window.scrollY > 0) {
        $header.classList.add('aps-header--shrink')
        scrollY = window.scrollY
      } else if (isHome) {
        $header.classList.add('aps-header--transparent')
      }

      window.addEventListener('scroll', function () {
        if (scrollY > 0 && window.scrollY === 0) {
          $header.classList.remove('aps-header--shrink')
          if ($main) $main.style.marginTop = '0'
          if (isHome && !isMobileMenuOpen && !isMegaMenuOpen) {
            $header.classList.add('aps-header--transparent')
          }
        } else if (scrollY === 0 && window.scrollY > 0) {
          if (isHome) {
            $header.classList.remove('aps-header--transparent')
          }
          $header.classList.add('aps-header--shrink')
          if ($main) $main.style.marginTop = '40px'
        }
        scrollY = window.scrollY
      })

      var $headerNav,
        $activeNavItem,
        $megaMenuItems,
        isMobileMenuOpen,
        isMegaMenuOpen = false

      var $mobileMenuIcon = $header.querySelector('.aps-header__icon--menu')

      $mobileMenuIcon.addEventListener('click', function (ev) {
        ev.preventDefault()
        if (!isMobileMenuOpen) {
          toggleMobileMenu()
          ev.stopPropagation()
        }
      })

      function toggleMobileMenu() {
        $headerNav = $headerNav || $header.querySelector('.aps-header__nav')
        var isOpening = $headerNav.classList.toggle('aps-header__nav--open')
        $mobileMenuIcon.classList.toggle('aps-header__icon--close')
        if (isHome && scrollY === 0) {
          if (isOpening) {
            $header.classList.remove('aps-header--transparent')
          } else {
            $header.classList.add('aps-header--transparent')
          }
        }
        isMobileMenuOpen = !isMobileMenuOpen
      }

      function openMegaMenu() {
        window.aps.$megaMenu.style.display = 'block'
        setTimeout(function () {
          window.aps.$megaMenu.classList.add('aps-mega-menu--open')
          isMegaMenuOpen = true
        }, 16)
      }

      Array.from($header.querySelectorAll('.aps-header__nav-item')).forEach(function ($navItem, index) {
        function setActiveMegaMenuItem() {
          if ($activeNavItem) {
            $activeNavItem.classList.remove('aps-header__nav-item--active')
            $activeNavItem = null
          }
          $megaMenuItems = $megaMenuItems || Array.from(document.querySelectorAll('.aps-mega-menu__nav'))
          $megaMenuItems.forEach(function ($megaMenuItem, i) {
            if (i === index) {
              $navItem.classList.add('aps-header__nav-item--active')
              $activeNavItem = $navItem
              $megaMenuItem.classList.add('aps-mega-menu__nav--active')
            } else {
              $megaMenuItem.classList.remove('aps-mega-menu__nav--active')
            }
          })
          if (!isMegaMenuOpen) {
            if (isHome && !isMobileMenuOpen && window.scrollY === 0) {
              $header.classList.remove('aps-header--transparent')
              setTimeout(openMegaMenu, 200)
            } else {
              openMegaMenu()
            }
          }
        }

        $navItem.addEventListener('click', function (ev) {
          ev.preventDefault()
          ev.stopPropagation()
          var href = $navItem.getAttribute('href')
          if (window.innerWidth < 992 || $navItem.classList.contains('aps-header__nav-item--active')) {
            window.location.href = href
          } else {
            setActiveMegaMenuItem()
          }
        })

        $navItem.nextElementSibling.addEventListener('click', function (ev) {
          ev.preventDefault()
          ev.stopPropagation()
          setActiveMegaMenuItem()
        })
      })

      window.addEventListener('click', function (ev) {
        if (window.aps.toggleUserDropdown) {
          window.aps.toggleUserDropdown(true)
        }
        if (isMegaMenuOpen) {
          window.aps.$megaMenu.classList.remove('aps-mega-menu--open')
          if ($activeNavItem) {
            $activeNavItem.classList.remove('aps-header__nav-item--active')
            $activeNavItem = null
          }
          setTimeout(function () {
            $megaMenuItems.forEach(function ($megaMenuItem) {
              $megaMenuItem.classList.remove('aps-mega-menu__nav--active')
            })
            window.aps.$megaMenu.style.display = 'none'
            if (isHome && !isMobileMenuOpen && window.scrollY === 0) {
              $header.classList.add('aps-header--transparent')
            }
            isMegaMenuOpen = false
          }, 300)
        }
        if (isMobileMenuOpen && !ev.target.classList.contains('aps-mega-menu__back')) {
          toggleMobileMenu()
          if (isHome && window.scrollY === 0) {
            $header.classList.add('aps-header--transparent')
          }
        }
      })

      var $headerSearch = $header.querySelector('.aps-header__icon--search')

      function toggleHeaderSearch() {
        var isActive = $headerSearch.classList.contains('aps-header__icon--active')
        if (isActive) {
          if (window.innerWidth > 991) {
            $headerSearch.classList.add('aps-header__icon--closing')
          }
          $headerSearch.classList.remove('aps-header__icon--active')

          setTimeout(function () {
            $headerSearch.classList.remove('aps-header__icon--closing')
          }, 200)
        } else {
          $headerSearch.classList.add('aps-header__icon--active')
          $headerSearch.focus()
        }
      }

      $headerSearch.addEventListener('click', function (ev) {
        ev.preventDefault()
        window.aps.toggleSearch()
        toggleHeaderSearch()
      })

      var $headerLogin = $header.querySelector('.aps-header__cta--login')

      if ($headerLogin) {
        $headerLogin.addEventListener('click', function (ev) {
          ev.preventDefault()
          window.aps.toggleLogin()
        })
      }

      if (!window.aps) window.aps = {}
      window.aps.toggleHeaderSearch = toggleHeaderSearch

      var $userDropdown = document.querySelector('.aps-dropdown--user')

      if ($userDropdown) {
        function toggleUserDropdown(hide) {
          $userDropdown.classList[hide === true ? 'remove' : 'toggle']('aps-dropdown--active')
        }

        $userDropdown
          .querySelector('.aps-dropdown__toggle')
          .addEventListener('click', function (ev) {
            ev.preventDefault()
            ev.stopPropagation()
            toggleUserDropdown()
          })

        window.aps.toggleUserDropdown = toggleUserDropdown
      }
    }
  })
}
